import { Component } from '@theme/component';
import { DialogComponent, DialogOpenEvent } from '@theme/dialog';

/**
 * The full inline header search input is a static form (no predictive results of its own).
 * As soon as the shopper starts typing, this opens the shared search modal and mirrors the
 * typed value into its predictive search input, so typing keeps flowing into the modal.
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} input - The visible header search input.
 *
 * @extends {Component<Refs>}
 */
class HeaderSearchFullComponent extends Component {
  requiredRefs = ['input'];

  /**
   * @param {InputEvent} event
   */
  handleInput = (event) => {
    if (!event.inputType) return;

    const searchModal = document.getElementById('search-modal');
    const modalInput = document.getElementById('cmdk-input');

    if (!(searchModal instanceof DialogComponent) || !(modalInput instanceof HTMLInputElement)) return;

    const { value } = this.refs.input;

    const sync = () => {
      modalInput.value = value;
      modalInput.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertFromPaste', data: value }));
      modalInput.focus();
      modalInput.setSelectionRange(value.length, value.length);
    };

    if (searchModal.refs.dialog?.open) {
      sync();
    } else {
      searchModal.addEventListener(DialogOpenEvent.eventName, sync, { once: true });
      searchModal.showDialog();
    }
  };
}

if (!customElements.get('header-search-full-component')) {
  customElements.define('header-search-full-component', HeaderSearchFullComponent);
}
